"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.animSettings = void 0;
const constants_1 = __importDefault(require("../../../../shared/constants"));
exports.animSettings = {
    dagger: {
        'xOffset': 45,
        'yOffset': -10,
        'sheathedXOffset': -5,
        'sheathedYOffset': 7,
        'sheathedRotation': 45,
        'weaponScale': 0.45,
        'tweenSprite': true,
        'startingWeaponAngle': 90,
        'startingHandAngle': 0,
        'tweenWeaponRotation': 90,
        'tweenHandRotation': 0,
        'tweenXOffset': 65,
        'tweenYOffset': -15,
        dualWeapon: true,
        'xOffset2': 45,
        'yOffset2': 10,
        'sheathedXOffset2': -5,
        'sheathedYOffset2': -7,
        'sheathedRotation2': 135,
        'tweenXOffset2': 65,
        'tweenYOffset2': 15,
        'tweenForwardDuration': 50,
        'tweenBackwardDuration': 50,
        'handsFrame': 'veryNarrow',
        handsTweenLeft: { x: 0, y: constants_1.default.PLAYER_SIZE.body - 20 },
        handsTweenRight: { x: 0, y: constants_1.default.PLAYER_SIZE.body - 20 },
    },
    flame: {
        'xOffset': 45,
        'yOffset': -10,
        'sheathedXOffset': -10,
        'sheathedYOffset': 7,
        'sheathedRotation': 45,
        'weaponScale': 0.45,
        'tweenSprite': true,
        'startingWeaponAngle': 90,
        'startingHandAngle': 0,
        'tweenWeaponRotation': 90,
        'tweenHandRotation': 0,
        'tweenXOffset': 65,
        'tweenYOffset': -15,
        dualWeapon: true,
        'xOffset2': 45,
        'yOffset2': 10,
        'sheathedXOffset2': -10,
        'sheathedYOffset2': -7,
        'sheathedRotation2': 135,
        'tweenXOffset2': 65,
        'tweenYOffset2': 15,
        'tweenForwardDuration': 50,
        'tweenBackwardDuration': 50,
        'handsFrame': 'veryNarrow',
        handsTweenLeft: { x: 0, y: constants_1.default.PLAYER_SIZE.body - 20 },
        handsTweenRight: { x: 0, y: constants_1.default.PLAYER_SIZE.body - 20 },
    },
    sword: {
        'xOffset': 20,
        'yOffset': -40,
        'sheathedXOffset': -12,
        'sheathedYOffset': -25,
        'sheathedRotation': 0,
        'weaponScale': 0.75,
        'tweenSprite': true,
        'startingWeaponAngle': 0,
        'startingHandAngle': 0,
        'tweenWeaponRotation': 90,
        'tweenHandRotation': 90,
        'tweenXOffset': 53,
        'tweenYOffset': 25,
        'tweenForwardDuration': 150,
        'tweenBackwardDuration': 150,
        'handsFrame': 'veryNarrow',
        handsTweenLeft: { x: 10, y: constants_1.default.PLAYER_SIZE.body - 20 },
        handsTweenRight: { x: -10, y: constants_1.default.PLAYER_SIZE.body - 20 },
    },
    darkSword: {
        'xOffset': 20,
        'yOffset': -45,
        'sheathedXOffset': -20,
        'sheathedYOffset': -25,
        'sheathedRotation': 0,
        'weaponScale': 0.25,
        'tweenSprite': true,
        'startingWeaponAngle': 0,
        'startingHandAngle': 0,
        'tweenWeaponRotation': 90,
        'tweenHandRotation': 90,
        'tweenXOffset': 53,
        'tweenYOffset': 25,
        'tweenForwardDuration': 150,
        'tweenBackwardDuration': 275,
        'handsFrame': 'veryNarrow',
        handsTweenLeft: { x: 10, y: constants_1.default.PLAYER_SIZE.body - 20 },
        handsTweenRight: { x: -10, y: constants_1.default.PLAYER_SIZE.body - 20 },
    },
    iceBane: {
        'xOffset': 20,
        'yOffset': -45,
        'sheathedXOffset': -20,
        'sheathedYOffset': -25,
        'sheathedRotation': 0,
        'weaponScale': 0.5,
        'tweenSprite': true,
        'startingWeaponAngle': 0,
        'startingHandAngle': 0,
        'tweenWeaponRotation': 90,
        'tweenHandRotation': 90,
        'tweenXOffset': 53,
        'tweenYOffset': 25,
        'tweenForwardDuration': 150,
        'tweenBackwardDuration': 150,
        'handsFrame': 'veryNarrow',
        handsTweenLeft: { x: 10, y: constants_1.default.PLAYER_SIZE.body - 20 },
        handsTweenRight: { x: -10, y: constants_1.default.PLAYER_SIZE.body - 20 },
    },
    moonblade: {
        'xOffset': 20,
        'yOffset': -45,
        'sheathedXOffset': -10,
        'sheathedYOffset': -25,
        'sheathedRotation': 0,
        'weaponScale': 0.5,
        'tweenSprite': true,
        'startingWeaponAngle': 0,
        'startingHandAngle': 0,
        'tweenWeaponRotation': 90,
        'tweenHandRotation': 90,
        'tweenXOffset': 53,
        'tweenYOffset': 25,
        'tweenForwardDuration': 150,
        'tweenBackwardDuration': 150,
        'handsFrame': 'veryNarrow',
        handsTweenLeft: { x: 10, y: constants_1.default.PLAYER_SIZE.body - 20 },
        handsTweenRight: { x: -10, y: constants_1.default.PLAYER_SIZE.body - 20 },
    },
    spear: {
        'xOffset': 20,
        'yOffset': 17,
        'sheathedXOffset': -12,
        'sheathedYOffset': 0,
        'sheathedRotation': 90,
        'weaponScale': 0.4,
        'tweenSprite': true,
        'startingWeaponAngle': 0,
        'startingHandAngle': 0,
        'tweenWeaponRotation': 0,
        'tweenHandRotation': 0,
        'tweenXOffset': 50,
        'tweenYOffset': 17,
        'tweenForwardDuration': 125,
        'tweenBackwardDuration': 350,
        'handsFrame': 'spear',
        handsTweenLeft: { x: 23, y: constants_1.default.PLAYER_HAND_POSITIONS['spear'].left[1] },
        handsTweenRight: { x: 43, y: constants_1.default.PLAYER_HAND_POSITIONS['spear'].right[1] },
        preTweenDuration: 50,
        preTweenLeft: { x: -23, y: constants_1.default.PLAYER_HAND_POSITIONS['spear'].left[1] },
        preTweenRight: { x: -43, y: constants_1.default.PLAYER_HAND_POSITIONS['spear'].right[1] },
        'preTweenXOffset': 5,
        'preTweenYOffset': 17,
    },
    katana: {
        'xOffset': 20,
        'yOffset': -50,
        'sheathedXOffset': -12,
        'sheathedYOffset': -25,
        'sheathedRotation': 0,
        'weaponScale': 0.5,
        'tweenSprite': true,
        'startingWeaponAngle': 0,
        'startingHandAngle': 0,
        'tweenWeaponRotation': 90,
        'tweenHandRotation': 90,
        'tweenXOffset': 53,
        'tweenYOffset': 25,
        'tweenForwardDuration': 150,
        'tweenBackwardDuration': 150,
        'handsFrame': 'veryNarrow',
        handsTweenLeft: { x: 10, y: constants_1.default.PLAYER_SIZE.body - 20 },
        handsTweenRight: { x: -10, y: constants_1.default.PLAYER_SIZE.body - 20 },
        flipX: true
    },
    staff: {
        'xOffset': 20,
        'yOffset': -50,
        'sheathedXOffset': -12,
        'sheathedYOffset': -25,
        'sheathedRotation': 0,
        'weaponScale': 0.2,
        'tweenSprite': true,
        'startingWeaponAngle': 40,
        'startingHandAngle': 0,
        'tweenWeaponRotation': 130,
        'tweenHandRotation': 90,
        'tweenXOffset': 53,
        'tweenYOffset': 25,
        'tweenForwardDuration': 150,
        'tweenBackwardDuration': 150,
        'handsFrame': 'veryNarrow',
        handsTweenLeft: { x: 10, y: constants_1.default.PLAYER_SIZE.body - 20 },
        handsTweenRight: { x: -10, y: constants_1.default.PLAYER_SIZE.body - 20 },
    },
    morningStar: {
        'xOffset': 20,
        'yOffset': -40,
        'sheathedXOffset': -12,
        'sheathedYOffset': -25,
        'sheathedRotation': 0,
        'weaponScale': 0.25,
        'tweenSprite': true,
        'startingWeaponAngle': 0,
        'startingHandAngle': 0,
        'tweenWeaponRotation': 90,
        'tweenHandRotation': 90,
        'tweenXOffset': 53,
        'tweenYOffset': 25,
        'tweenForwardDuration': 200,
        'tweenBackwardDuration': 450,
        'handsFrame': 'veryNarrow',
        handsTweenLeft: { x: 10, y: constants_1.default.PLAYER_SIZE.body - 20 },
        handsTweenRight: { x: -10, y: constants_1.default.PLAYER_SIZE.body - 20 },
    },
    shotgun: {
        // 'xOffset': 20,
        'xOffset': 35,
        'yOffset': 17,
        'sheathedXOffset': -12,
        'sheathedYOffset': 0,
        'sheathedRotation': 90,
        'weaponScale': 0.7,
        'tweenSprite': true,
        'startingWeaponAngle': 0,
        'startingHandAngle': 0,
        // 'tweenWeaponRotation': 90,
        'tweenWeaponRotation': 0,
        'tweenHandRotation': 0,
        // 'tweenXOffset': 50,
        // 'tweenYOffset': 17,
        'tweenXOffset': 0,
        'tweenYOffset': 17,
        'tweenForwardDuration': 125,
        'tweenBackwardDuration': 125,
        'handsFrame': 'spear',
        // handsTweenLeft: { x: 23, y: Constants.PLAYER_HAND_POSITIONS['spear'].left[1] },
        // handsTweenRight: { x: 43, y: Constants.PLAYER_HAND_POSITIONS['spear'].right[1] },
        handsTweenLeft: { x: -10, y: constants_1.default.PLAYER_HAND_POSITIONS['spear'].left[1] },
        handsTweenRight: { x: -30, y: constants_1.default.PLAYER_HAND_POSITIONS['spear'].right[1] },
        // handsTweenLeft: { x: 3, y: Constants.PLAYER_HAND_POSITIONS['spear'].left[1] },
        // handsTweenRight: { x: 23, y: Constants.PLAYER_HAND_POSITIONS['spear'].right[1] },
        // preTweenDuration: 0,
        // preTweenLeft: { x: -23, y: Constants.PLAYER_HAND_POSITIONS['spear'].left[1] },
        // preTweenRight: { x: -43, y: Constants.PLAYER_HAND_POSITIONS['spear'].right[1] },
        //
        // 'preTweenXOffset': 5,
        // 'preTweenYOffset': 17,
    },
};
